module.exports = __webpack_public_path__ + "img/banner5.1b73785c.jpg";